var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#717172",
    d: "M18.333 28.333c0 .917.75 1.667 1.667 1.667s1.667-.75 1.667-1.667c0-.916-.75-1.666-1.667-1.666s-1.667.75-1.667 1.666m0-23.333v6.667h3.334v-3.2c5.65.808 10 5.658 10 11.533 0 6.442-5.225 11.667-11.667 11.667S8.333 26.442 8.333 20c0-2.8.984-5.358 2.625-7.375L20 21.667l2.358-2.359L11.025 7.975l-.017.033C7.367 10.742 5 15.092 5 20c0 8.283 6.7 15 14.992 15C28.283 35 35 28.283 35 20S28.283 5 19.992 5zM30 20c0-.917-.75-1.667-1.667-1.667-.916 0-1.666.75-1.666 1.667s.75 1.667 1.666 1.667c.917 0 1.667-.75 1.667-1.667m-20 0c0 .917.75 1.667 1.667 1.667.916 0 1.666-.75 1.666-1.667s-.75-1.667-1.666-1.667c-.917 0-1.667.75-1.667 1.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgClock;